import { createAction, props } from '@ngrx/store';

import { AuditScreen } from '../audit-screen.enum';

export enum SharedAuditActionTypes {}

export const EnableAudit = createAction(
  '[SharedAudit] Enable Audit',
  props<{ auditScreen: AuditScreen | null; auditScreens: AuditScreen[] | null }>()
);

export const DisableAudit = createAction('[SharedAudit] Disable Audit');

export const ShowAuditDrawer = createAction('[SharedAudit] Show Audit Drawer');

export const HideAuditDrawer = createAction('[SharedAudit] Hide Audit Drawer');

export const SelectAuditScreen = createAction(
  '[SharedAudit] Select Audit Screen',
  props<{ selectedAuditScreen: AuditScreen }>()
);
